export const PALLET_STATES = [
  'built',
  'stored',
  'pulled',
  'enroute',
  'flagged',
  'discarded',
  'shipped',
  'on_trailer',
] as const;

export type PalletState = (typeof PALLET_STATES)[number];

export interface TransferablesRegion {
  id: number;
  name: string;
}

export interface TransferablesWarehouse {
  id: number;
  name: string;
  region_ids: number[];
}

export interface TransferablesCustomer {
  id: number;
  account_id: number;
  name: string;
}

export interface TransferablesWarehouseSummary {
  id: number;
  name: string;
}

export interface TransferablesPalletGrade {
  score: string;
  image?: {
    source: string;
  } | null;
}

export interface TransferablesPalletLocation {
  id: number;
  value: string;
  barcode: {
    value: string;
  };
}

export interface TransferablesActiveTransferRequest {
  id: number;
  destination: TransferablesWarehouseSummary;
}

export interface TransferablesPallet {
  id: number;
  state: string;
  items_count: number;
  requested_count: number;
  account_ids: number[];
  transfer_ids: number[];
  barcode: {
    value: string;
  };
  grade?: TransferablesPalletGrade | null;
  location?: TransferablesPalletLocation | null;
  active_transfer_request?: TransferablesActiveTransferRequest | null;
  customers?: TransferablesCustomer[];
}

export interface Transferable {
  warehouse: TransferablesWarehouseSummary;
  pallets: TransferablesPallet[];
}

export interface TransferablesFilters {
  region_id?: number;
  warehouse_id?: number;
  state?: PalletState;
  from?: Date;
  till?: Date;
}

export interface DateConstraints {
  from: { min: Date; max: Date };
  till: { min: Date; max: Date };
}

export interface TransferRequestForm {
  pallet_ids: number[];
  origin_id: number;
  destination_id?: number;
}
